import { SESSION_EXPIRED } from '../../actions/types';
import config from '../../assets/config';
import { getAccessToken } from '../auth';
// Direct store import (same pattern as internalApi.js).
// Lives in its own module — not restApiSliceLegacy.ts — because store.jsx imports
// that slice at module-eval time and the import cycle would crash on load.
import store from '../../store';

type LegacyAPIRequest = {
  url: RequestInfo;
  method: RequestInit['method'];
  body?: object;
  signal?: AbortSignal;
};

export async function legacyAPIRequest({ url, method, body, signal }: LegacyAPIRequest): Promise<Response> {
  // Once the session is expired, fail fast with the same shape a real 401 would have —
  // no point hitting the server without credentials.
  if (store.getState().keycloak.sessionExpired) {
    return new Response(null, { status: 401 });
  }

  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  const accessToken = getAccessToken();
  if (accessToken) {
    headers.set('x-prerender-authorization', accessToken);
  }

  const options: RequestInit = {
    headers,
    method,
    signal,
  };

  if (body) options.body = JSON.stringify(body);

  const request = new Request(`${config.apiUrl.dataServer}/api/${url}`, options);

  const response = await fetch(request);

  // Dispatch SESSION_EXPIRED on 401 so the unified modal appears regardless of which page is active
  if (response.status === 401 && !store.getState().keycloak.sessionExpired) {
    store.dispatch({ type: SESSION_EXPIRED });
  }

  return response;
}
